import {DsAvatar} from "ch3-ui-lib";
import {Call} from "../../store/features/calls/callsService";
import {getFullName} from "../../utilis/getFullName";
import CallTimer from "./CallTimer";
import {callRowView} from "./callRowView";
import {CallerAvatar, LineTile, NumberFlag} from "./callParts";

export interface OnGoingCallProps {
    call: Call;
}

// A call in progress: warning-tint row with a live pill (dot, direction, timer) and who handles it.
export const OnGoingCall = ({call}: OnGoingCallProps) => {
    const view = callRowView(call);
    const direction = call.type === 'OUTBOUND' ? 'Outgoing' : 'Incoming';

    return (
        <div data-testid="ongoing-call" className="flex min-h-[76px] items-center gap-3 rounded-control bg-warning-tint px-2 py-2">
            <CallerAvatar call={call} view={view}/>
            <div className="flex min-w-0 flex-1 flex-col gap-1">
                <div className="flex min-w-0 items-center gap-2 text-callout font-semibold text-ink">
                    {!view.known && call.clientMsisdn && <NumberFlag msisdn={call.clientMsisdn}/>}
                    <span className="truncate">{view.name}</span>
                </div>
                <div className="flex items-center">
                    <span className="inline-flex h-5 items-center gap-[5px] rounded-badge bg-warning-tint px-[7px] text-micro text-warning-ink shadow-[inset_0_0_0_1px_var(--warning-line)]">
                        <span aria-hidden="true" className="size-1.5 rounded-full bg-warning"/>
                        {direction}
                        {call.bridgetAt && <> · <CallTimer call={call}/></>}
                    </span>
                </div>
                {call.user && (
                    <div className="flex items-center gap-1.5 text-footnote text-ink-secondary">
                        Handled by
                        <span className="inline-flex h-[26px] items-center gap-1.5 rounded-chip bg-surface-muted px-2.5 text-footnote font-medium text-ink">
                            <DsAvatar size={20} name={getFullName(call.user.firstName, call.user.lastName)} src={call.user.avatarUrl || undefined}/>
                            {getFullName(call.user.firstName, call.user.lastName)}
                        </span>
                    </div>
                )}
            </div>
            <LineTile call={call}/>
        </div>
    );
};
